import { useEffect, useState } from "react";
import { MessageCircle } from "lucide-react";
import { WHATSAPP } from "@/lib/contacto";
import { track } from "@/lib/analytics";

const SECCIONES: Array<{ id: string; mensaje: string }> = [
  {
    id: "productos",
    mensaje: "Hola, vi los productos NFC + QR y quiero consultar por modelos y precios",
  },
  {
    id: "proceso",
    mensaje: "Hola, quiero saber cómo personalizan y configuran los productos NFC + QR",
  },
  {
    id: "nosotros",
    mensaje: "Hola, quiero conversar sobre un producto NFC para mi negocio",
  },
  {
    id: "contacto",
    mensaje: "Hola, quiero cotizar un producto NFC + QR para mi negocio",
  },
];

const MENSAJE_POR_DEFECTO = "Hola, quiero saber más sobre los productos NFC + QR de Pyme Visible";

function urlWhatsapp(mensaje: string) {
  const base = WHATSAPP.split("?")[0];
  return `${base}?text=${encodeURIComponent(mensaje)}`;
}

export function WhatsAppFloat() {
  const [visible, setVisible] = useState(false);
  const [mensaje, setMensaje] = useState(MENSAJE_POR_DEFECTO);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 400);
    };
    const visibles = new Set<string>();
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) visibles.add(entry.target.id);
          else visibles.delete(entry.target.id);
        }
        setMensaje(
          SECCIONES.filter((seccion) => visibles.has(seccion.id)).at(-1)?.mensaje ??
            MENSAJE_POR_DEFECTO,
        );
      },
      { rootMargin: "0px 0px -50% 0px" },
    );
    for (const seccion of SECCIONES) {
      const element = document.getElementById(seccion.id);
      if (element) observer.observe(element);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", onScroll);
      observer.disconnect();
    };
  }, []);

  return (
    <a
      href={urlWhatsapp(mensaje)}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Escríbenos por WhatsApp"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
      onClick={() => track("whatsapp_click", { ubicacion: "boton_flotante" })}
      className={`pv-whatsapp-float fixed bottom-5 right-4 z-50 inline-flex min-h-12 min-w-12 items-center justify-center gap-2 rounded-full p-3 font-semibold text-white transition-all duration-300 hover:scale-105 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-navy sm:bottom-8 sm:right-8 sm:px-4 sm:py-3.5 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-4 opacity-0"
      }`}
    >
      <MessageCircle className="h-6 w-6" aria-hidden="true" />
      <span className="hidden text-sm sm:inline">Hablemos por WhatsApp</span>
    </a>
  );
}
